<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <pdq-heading element="h5">Token for Shopify</pdq-heading>
    </div>
    <pdq-divider></pdq-divider>
    <div class="card__content">
      <pdq-link
        label="View detailed installation instructions"
        [external]="true"
        [url]="'https://support.prettydamnquick.com/en/articles/8560867-adding-multiple-pdq-components'"></pdq-link>
      <pdq-input
        [disabled]="true"
        [formControl]="formGroup.get('usageToken')"
        label="Copy & paste this into Shopify's Components by 'Product promise token'"
        [clipboard]="true"></pdq-input>
    </div>
  </div>
</pdq-card>
<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <pdq-heading element="h5">Settings</pdq-heading>
    </div>
    <pdq-divider></pdq-divider>
    <div class="card__content">
      <pdq-input
        [formControl]="formGroup.get('internalName')"
        label="Internal Name*"
        placeholder="Product Promise"
        [invalid]="formGroup.get('internalName')?.errors?.required"
        invalidMsg="Internal name is required"></pdq-input>
      <pdq-input
        [formControl]="formGroup.get('internalDescription')"
        label="Internal Description"
        placeholder="Product Promise"></pdq-input>
    </div>
  </div>
</pdq-card>
@if (!isProService) {
  <pdq-card variant="popover" color="white">
    <div class="card">
      <div class="card__header">
        <div class="card__header__text">
          <pdq-heading element="h5">Extension mode</pdq-heading>
          <span class="card__subtitle">Choose which configuration mode you'd like</span>
        </div>
      </div>
      <pdq-divider></pdq-divider>
      <div class="card__content">
        <div class="layout-mode-options">
          <div
            class="layout-mode-option"
            [class.selected]="isBasicSelected"
            (click)="selectLayoutMode(LayoutMode.BASIC)">
            <div class="layout-mode-radio-indicator" [class.checked]="isBasicSelected"></div>
            <div class="layout-mode-option-content">
              <span class="layout-mode-option-title">Basic</span>
              <span class="layout-mode-option-subtitle">Simple Setup</span>
            </div>
          </div>
          <div
            class="layout-mode-option"
            [class.selected]="isAdvancedSelected"
            (click)="selectLayoutMode(LayoutMode.ADVANCED)">
            <div class="layout-mode-radio-indicator" [class.checked]="isAdvancedSelected"></div>
            <div class="layout-mode-option-content">
              <span class="layout-mode-option-title">Advanced</span>
              <span class="layout-mode-option-subtitle">Full control and customization</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </pdq-card>
}
